<template>
  <div class="root">
    <section>
      <div class="container">
        <h3 class="rux-list-title">My RUX</h3>
        <div class="row" v-if="ruxList && ruxList.length > 0">
          <div
            v-for="(item, index) in ruxList"
            :key="index"
            class="col-12 col-sm-6 list-wrapper"
          >
            <RuxCard :clickTarget="{ name: 'Details', params: { serialNumber: item.serialNumber } }" :rux="item" :images="getImages(item.serialNumber)">{{
              item.images
            }}</RuxCard>
          </div>
        </div>
        <div v-else>You aint got none!</div>
      </div>
    </section>
  </div>
</template>

<script>
import RuxCard from './RuxCard'
export default {
  name: 'RuxList',
  components: { RuxCard },
  computed: {
    // Get the list of RUX from the store
    ruxList: function () {
      return this.$store.state.rux.ruxList
    },
    // Get all the image URLS from the store
    imageList: function () {
      return this.$store.state.rux.imageList
    },
  },
  methods: {
    // This finds the images that are associated with the RUX that is being iterated and returns the first 2.
    getImages: function (serialNumber) {
      if (this.imageList && this.imageList.length > 0) {
        return this.imageList
          .find((images) => {
            return images.serialNumber === serialNumber
          })
          .images.slice(0, 2)
      } else {
        return []
      }
    },
  },
  mounted() {
    if (this.imageList && this.imageList.length === 0) {
      this.$store.dispatch('rux/getAllImages')
    }
  },

  // This just watches RuxList to make sure there are some there before updating.
  // ruxList is updated in the App as soon as the page loads in another location so no need to reload it here
  watch: {
    ruxList(newVal) {
      if (newVal.length > 0) {
        this.$store.dispatch('rux/getAllImages')
      }
    },
  },
}
</script>

<style lang='scss' scoped>
.rux-list-title {
  font-family: "Neue Roman";
  font-size: 30px;
  text-align: left;
  margin-bottom: 20px;
}
.rux-list-container {
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
section {
  margin-top: 40px;
  .list-wrapper {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}
</style>